export const numbersWithCommas = number => {
  if (number >= 1000) {
    return number
      .toString()
      .replace(/,/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return number
}
